module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-youtube.c1e1fa5f.svg";